import { Container, H3, MainLink, Icon, H2, P3, P2, useWindowSize } from '@moneymade/moneymade-ui'
import PropTypes from 'prop-types'

import styles from './TrackRecord.module.scss'

const TrackRecord = ({ urlSlug, title, website, records }) => {
  const { screenWidth } = useWindowSize()

  return (
    <div className={styles.TrackRecord}>
      <Container width={1230} className={styles.Content}>
        <div className={styles.Header}>
          <H3 weight="semibold" className={styles.Title} id={urlSlug}>
            {title}
          </H3>
          {screenWidth >= 601 ? (
            <MainLink
              href={website}
              size="md"
              weight="normal"
              target="_blank"
              rel="noreferrer"
              fontType="main"
              iconAfter={<Icon icon="icon-external-link" size={16} />}
            >
              Visit Website
            </MainLink>
          ) : null}
        </div>
        <div className={styles.Records}>
          {records.map(({ value, text, description }, index) => (
            <div key={index} className={styles.Record}>
              <H2 weight="semibold">{value}</H2>
              <P3 weight="light" className={styles.Text}>
                {text}
              </P3>
              <div className={styles.Line} />
              <P2 weight="light">{description}</P2>
            </div>
          ))}
        </div>

        {screenWidth < 601 ? (
          <MainLink
            href={website}
            size="md"
            weight="normal"
            target="_blank"
            rel="noreferrer"
            fontType="main"
            iconAfter={<Icon icon="icon-external-link" size={16} />}
            className={styles.Visit}
          >
            Visit Website
          </MainLink>
        ) : null}
      </Container>
    </div>
  )
}

TrackRecord.propTypes = {
  title: PropTypes.string,
  urlSlug: PropTypes.string,
  website: PropTypes.string,
  records: PropTypes.arrayOf(PropTypes.object)
}

TrackRecord.defaultProps = {
  title: '',
  urlSlug: '',
  website: '',
  records: []
}

export default TrackRecord
